import { SurveyDispatchReportPage } from './SurveyDispatchReportPage';

export function NpsDispatchReportPage() {
  return (
    <SurveyDispatchReportPage
      surveyType="Nps"
      title="NPS"
      description="NPS (Net Promoter Score) mede a disposição do cliente em recomendar sua empresa, numa escala típica de 0 a 10. Neste relatório você acompanha cada pesquisa enviada — status, nota, comentário e data da resposta — para identificar promotores, neutros e detratores."
      emptyMessage="Nenhuma pesquisa NPS enviada no período."
      loadErrorMessage="Falha ao carregar o relatório de NPS."
    />
  );
}
